import { BaseHelper } from './BaseGraphQLAPIHelper';

export const getGroups = (afterCursor = '', moreSearch) => {
  let orderBy = '-pk';
  if (!moreSearch?.rank) {
    orderBy = 'pk';
  }
  if (moreSearch?.sort) {
    orderBy = moreSearch.sort;
  }
  const search = moreSearch?.search ? moreSearch.search : '';
  const query = `{
    customerGroups(${
      moreSearch.isAll ? '' : 'first: 20'
    }, after:"${afterCursor}", orderBy:"${orderBy}", name: "${search}") {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ${
            moreSearch?.isSelectorLoad
              ? `id
          pk
          name
          `
              : `id
          pk
          name
          description
          creationDate
          ${
            moreSearch?.fromList
              ? 'members'
              : `customers {
            edges {
              node {
                pk
                id
                firstName
                lastName
                ssoUid
              }
            }
          }`
          }
            `
          }
        }
      }
    }
  }
  `;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getCustomerGroup = (id) => {
  const query = `
  {
    customerGroup(id: "${id}") {
      id
      pk
      name
      description
      members
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteCustomerGroups = (ids) => {
  const query = `
  mutation DeleteCustomerGroups($input: DeleteCustomerGroupsInput!) {
    deleteCustomerGroups(input: $input) {
      success
    }
  }`;
  const variables = {
    input: {
      ids: ids,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createCustomerGroup = (inputBody) => {
  const query = `
  mutation CreateCustomerGroup($input: CreateCustomerGroupInput!) {
    createCustomerGroup(input: $input) {
      node {
        id
        pk
        name
        description
        customers {
          edges {
            node {
              id
              pk
              firstName
              lastName
              nickname
            }
          }
        }
      }
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateCustomerGroup = (inputBody) => {
  const query = `
  mutation UpdateCustomerGroup($input: UpdateCustomerGroupInput!) {
    updateCustomerGroup(input: $input) {
      node {
        id
        pk
        name
        description
        customers {
          edges {
            node {
              id
              pk
              firstName
              lastName
              nickname
            }
          }
        }
      }
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};
